module.exports = __webpack_public_path__ + "static/media/76.69e9731b.gif";